<!-- 硬件管理中心 -->
<template>
  <div :class="['hardware-center', cardList.length < 3 ? 'hardware-center-auto' : '']">
    <hardware-head class="training-head" @onSearchVal="onSearchVal"></hardware-head>
    <div class="hardware-center-list">
      <div
        :class="['hardware-list-card', cardList.length === 1 ? 'card-auto' : '']"
        v-for="(item, index) in cardList"
        :key="index"
        @click="onHardwareDetails"
      >
        <img v-if="item.imageUrl" :src="item.imageUrl" alt="" />
        <img v-else src="../../assets/images/upload-bg.png" alt="" />
        <div class="equipment-list">
          <div
            class="equipment-state"
            v-for="(i, idx) in item.equipmentList"
            :key="idx"
          >
            <span class="equipment-name">
              <span>{{ i.title }}</span>
              <span>{{ i.title2 }}</span>
            </span>
            <span
              :class="[
                'equipment-on-line',
                i.state === '离线' ? 'equipment-off-line' : '',
              ]"
            >
              <i class="icon"></i>{{ i.state }}
            </span>
            <span class="equipment-ip" v-if="i.state === '在线' ? true : false"
              >ID: {{ i.ip }}</span
            >
            <div class="equipment-connect">
              <el-tooltip :content="i.connect" placement="top">
                <el-switch
                  v-model="i.connect"
                  active-color="#278AFF"
                  inactive-color="#ccc"
                  active-value="已连接"
                  inactive-value="未连接"
                  @click.stop.native
                  v-if="i.connect"
                >
                </el-switch>
              </el-tooltip>
              <span class="equipment-connect-text">{{ i.connect }}</span>
            </div>
            <div class="line" v-show="idx < 2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HardwareHead from './HardwareHead.vue'

export default {
  name: 'hardware-center',
  components: { HardwareHead },
  data() {
    return {
      cardListAll: [
        {
          imageUrl: require('../../assets/images/hardwareManagement/pic01.png'),
          equipmentList: [
            {
              title: '摄像头1',
              title2: '前台',
              ip: '10.1.20.101',
              state: '在线',
              connect: '未连接',
            },
            {
              title: '摄像头2',
              title2: '大厅',
              ip: '10.1.20.101',
              state: '在线',
              connect: '已连接',
            },
            {
              title: '摄像头3',
              title2: '厨房',
              ip: '10.1.20.101',
              state: '离线',
              connect: '',
            },
          ],
        },
        {
          imageUrl: require('../../assets/images/hardwareManagement/pic02.png'),
          equipmentList: [
            {
              title: '机械臂1',
              title2: '前台',
              ip: '10.1.20.101',
              state: '在线',
              connect: '未连接',
            },
            {
              title: '机械臂2',
              title2: '大厅',
              ip: '10.1.20.101',
              state: '在线',
              connect: '已连接',
            },
            {
              title: '机械臂3',
              title2: '厨房',
              ip: '10.1.20.101',
              state: '离线',
              connect: '',
            },
          ],
        },
        {
          imageUrl: require('../../assets/images/hardwareManagement/pic03.png'),
          equipmentList: [
            {
              title: 'AGV无人小车1',
              title2: '前台',
              ip: '10.1.20.101',
              state: '在线',
              connect: '未连接',
            },
            {
              title: 'AGV无人小车2',
              title2: '大厅',
              ip: '10.1.20.101',
              state: '在线',
              connect: '已连接',
            },
            {
              title: 'AGV无人小车3',
              title2: '厨房',
              ip: '10.1.20.101',
              state: '离线',
              connect: '',
            },
          ],
        },
        {
          imageUrl: require('../../assets/images/hardwareManagement/pic04.png'),
          equipmentList: [
            {
              title: 'AI音响1',
              title2: '前台',
              ip: '11.1.20.101',
              state: '在线',
              connect: '未连接',
            },
            {
              title: 'AI音响2',
              title2: '大厅',
              ip: '12.1.20.101',
              state: '在线',
              connect: '已连接',
            },
            {
              title: 'AI音响3',
              title2: '厨房',
              ip: '12.1.20.101',
              state: '离线',
              connect: '',
            },
          ],
        },
      ],
      cardList: []
    }
  },
  created() {
    this.cardList = this.cardListAll
  },
  methods: {
    onSearchVal(val) {
      let arrSearch = [],
        cardList = JSON.parse(JSON.stringify(this.cardListAll));
      arrSearch = cardList.filter((item) => {
        return item.equipmentList.some((i) => {
          return i.title.indexOf(val) !== -1 || i.ip.indexOf(val) !== -1
        })
      })
      this.cardList = arrSearch ? arrSearch : this.cardListAll
    },
    // 进入硬件详情
    onHardwareDetails() {
      this.$router.push({
        name: 'hardware-details',
      })
    },
    switchChange(val) {
      // console.log(val)
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.hardware-center {
  width: 100%;
  // height: 100%;
  background: linear-gradient(90deg, #9688ff, #188aff);
  padding: 0 50px 150px;
  .hardware-center-list {
    // width: 1200px;
    margin: 0 auto;
    // background-color: skyblue;
    padding-top: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .hardware-list-card {
      // width: 880px;
      // width: 48.5%;
      width: 45vw;
      min-width: 670px;
      height: 310px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 0px 12px 0px rgba(1, 14, 47, 0.2);
      border-radius: 20px;
      margin-bottom: 40px;
      display: flex;
      cursor: pointer;
      img {
        width: 120px;
        height: 120px;
        background: #ffffff;
        border: 2px solid #ffffff;
        border-radius: 60px;
        // margin: 93px 53px 93px 50px;
        margin: 93px 3vw 93px 3vw;
        box-sizing: border-box;
      }
      .equipment-list {
        display: flex;
        flex-direction: column;
        padding-right: 36px;
        .equipment-state {
          // width: 620px;
          width: 30vw;
          min-width: 440px;
          height: 100px;
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          line-height: 100px;
          position: relative;
          span {
            color: #ffffff;
            // margin-right: 10px;
          }
          .equipment-name {
            // width: 160px;
            width: 30%;
            display: flex;
            flex-direction: column;
            padding-top: 30px;
            span {
              line-height: 1;
              margin-right: 0;
            }
            span:first-child {
              font-size: 18px;
              margin-bottom: 4px;
            }
            span:last-child {
              opacity: 0.8;
            }
          }
          .equipment-on-line {
            font-size: 12px;
            .icon {
              width: 20px;
              height: 20px;
              display: inline-block;
              background: url('../../assets/images/hardwareManagement/on-line.png')
                no-repeat;
              background-size: contain;
              vertical-align: middle;
              margin-top: -5px;
              // margin-right: 20px;
              margin-right: 0.8vw;
            }
          }
          .equipment-off-line {
            color: rgba(255, 255, 255, 0.7);
            .icon {
              background: url('../../assets/images/hardwareManagement/off-line.png')
                no-repeat;
            }
          }
          .equipment-ip {
            // width: 9vw;
            width: 30%;
            text-align: right;
            // margin-left: 90px;
            // margin-left: 3vw;
          }

          .equipment-connect {
            position: absolute;
            top: 0;
            right: 0;
            span {
              margin-right: 0;
            }
            ::v-deep.el-switch__core {
              // width: 36px;
              // height: 18px;
              background: #278aff;
              border: 2px solid #ffffff !important;
              // margin-right: 20px;
              margin-right: 0.8vw;
              &:after {
                top: 0;
              }
            }
          }

          .line {
            width: 100%;
            height: 1px;
            background: #ffffff;
            opacity: 0.2;
          }
        }
      }
    }

    .card-auto {
      margin: 0 auto;
    }
  }
}

.hardware-center-auto {
  height: 100%;
  // .hardware-list-card {
  //   margin: 0 auto;
  // }
}

@media screen and (max-width: 1456px) {
  .hardware-list-card {
    margin: 0 auto;
  }
}
</style>
